import gql from "graphql-tag";

export default gql`
  mutation markConversationRead($conversationId: Int!) {
    markConversationRead(input: { conversationId: $conversationId }) {
      updatedCount
    }
  }
`;
